module.exports = __webpack_public_path__ + "img/grande.a8004733.jpg";